import { ReactNode } from "react";

import { sentryNavigatorLog } from "@src/features/experienceBuilder/toolbar/Navigator/storefront/NavigatorLog";
import { apolloStorefrontClient } from "@src/features/experienceBuilder/toolbar/Navigator/storefront/apolloStorefrontClient";

import { StorefrontNavigatorProvider } from "./StorefrontNavigatorProvider";

/**
 * The Navigator's data source: the Storefront API in the Preview
 * localization, for the org's own store and for a demo URL. The credential is
 * the only difference between the two, and the Storefront provider chooses it
 * from the store being previewed. This gives it the real client and log.
 */
export const NavigatorProvider = ({ children }: { children: ReactNode }) => (
  <StorefrontNavigatorProvider
    client={apolloStorefrontClient}
    log={sentryNavigatorLog}
  >
    {children}
  </StorefrontNavigatorProvider>
);
